import { create } from 'zustand'

export interface AttendeeRecord {
  key: string
  _id: string
  name: string
  gender?: string
  dob?: string
  organization: string
  team: string
  division: string
  checkInDate: string
  hasSubstitute: boolean
  substituteTeam?: string
  checkInId: string | null
  checkInStatus: string
  checkOutStatus?: string | null
  familyId?: string
  participantType?: 'kid' | 'guardian' | 'authorizedAdult' | 'dropInAttendee'
  dropInAttendeeId?: string
}

interface LeagueAttendanceState {
  ticketsModalOpen: boolean
  setTicketsModalOpen: (val: boolean) => void
  checkInOutModalOpen: boolean
  setCheckInOutModalOpen: (val: boolean) => void
  selectedDate: Date
  setSelectedDate: (date: Date) => void
  manageAttendeeModal: boolean
  checkInModal: boolean
  checkOutModal: boolean
  addDropInModalOpen: boolean
  dropInDetailModalOpen: boolean
  dropInMode: 'check-in' | 'check-out'
  rollCallModalOpen: boolean
  selectedAttendee: AttendeeRecord | null
  setManageAttendeeModal: (val: boolean) => void
  setCheckInModal: (val: boolean) => void
  setCheckOutModal: (val: boolean) => void
  setAddDropInModalOpen: (val: boolean) => void
  setDropInDetailModalOpen: (val: boolean) => void
  setDropInMode: (mode: 'check-in' | 'check-out') => void
  setRollCallModalOpen: (val: boolean) => void
  rollCallHistoryModalOpen: boolean
  setRollCallHistoryModalOpen: (val: boolean) => void
  setSelectedAttendee: (attendee: AttendeeRecord | null) => void
}

const leagueAttendanceStoreStates = (set: any): LeagueAttendanceState => ({
  ticketsModalOpen: false,
  setTicketsModalOpen: (val: boolean) => set(() => ({ ticketsModalOpen: val })),

  checkInOutModalOpen: false,
  setCheckInOutModalOpen: (val: boolean) =>
    set(() => ({ checkInOutModalOpen: val })),

  selectedDate: new Date(),
  setSelectedDate: (date: Date) => set(() => ({ selectedDate: date })),

  manageAttendeeModal: false,
  setManageAttendeeModal: (val: boolean) =>
    set(() => ({ manageAttendeeModal: val })),

  checkInModal: false,
  setCheckInModal: (val: boolean) => set(() => ({ checkInModal: val })),

  checkOutModal: false,
  setCheckOutModal: (val: boolean) => set(() => ({ checkOutModal: val })),

  addDropInModalOpen: false,
  setAddDropInModalOpen: (val: boolean) => set(() => ({ addDropInModalOpen: val })),

  dropInDetailModalOpen: false,
  setDropInDetailModalOpen: (val: boolean) => set(() => ({ dropInDetailModalOpen: val })),

  dropInMode: 'check-out' as 'check-in' | 'check-out',
  setDropInMode: (mode: 'check-in' | 'check-out') => set(() => ({ dropInMode: mode })),

  rollCallModalOpen: false,
  setRollCallModalOpen: (val: boolean) => set(() => ({ rollCallModalOpen: val })),

  rollCallHistoryModalOpen: false,
  setRollCallHistoryModalOpen: (val: boolean) => set(() => ({ rollCallHistoryModalOpen: val })),

  selectedAttendee: null,
  setSelectedAttendee: (attendee: AttendeeRecord | null) =>
    set(() => ({ selectedAttendee: attendee })),
})

export const leagueAttendanceStore = create<LeagueAttendanceState>(
  leagueAttendanceStoreStates,
)
